import React from "react";
import AppButton from "../../../../components/AppButton";
import AppConfirmDialog from "../../../../components/AppConfirmDialog";
import AppDialog from "../../../../components/AppDialog";
import AppDialogBody from "../../../../components/AppDialogBody";
import AppDialogFooter from "../../../../components/AppDialogFooter";
import AppDialogHeader from "../../../../components/AppDialogHeader";
import AppText from "../../../../components/AppText";
import { IconDelete, IconGlobal, IconInfo } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const appDialogIntro = "AppDialog = freie Shell für eigene Inhalte.";

const appDialogNotes = [
  "Sizes: sm, md, lg, xl → definiert Breite des Dialogs. XL ist für Builder mit Seitenleiste und grosser Vorschau vorgesehen.",
  "Höhe des Dialogs wird direkt vom Inhalt abgeleitet, kann aber bei Bedarf lokal begrenzt werden.",
  "Schliessen über Close-Button und Esc ist eingebaut; auf Overlay-Close wird bewusst verzichtet.",
];

const appDialogHighlights = [
  {
    number: "1",
    label: "Header (AppDialogHeader)",
    text: "Titel, Subtitle, Visual und Close-Button.",
  },
  {
    number: "2",
    label: "Body stack (AppDialogBody)",
    text: "Mehrere inset- und bleed-Zonen können direkt gestapelt werden.",
  },
  {
    number: "3",
    label: "Footer (AppDialogFooter)",
    text: "Optionaler startContent-Slot links, Aktionen rechts.",
  },
];

const confirmDialogIntro = "AppConfirmDialog = fertiges Pattern für kurze Entscheidungen.";

const confirmDialogNotes = [
  "Header, Body und Footer sind bereits fertig aufgebaut.",
  "Nur für kurze Info-, Bestätigung oder Lösch-Dialog verwenden",
  "Dialog NICHT anpassen! Nur Inhalt (Title, Description, Icon) darf frei gewählt werden"
];

const confirmDialogHighlights = [
  "Actions: confirmLabel, cancelLabel, confirmTone.",
  "confirmTone error für destruktive Entscheidungen.",
];

function DialogSection({ title, intro, notes, highlights = [], wide = false, children }) {
  const classes = [
    "ds-docs-dialog-section-grid",
    wide ? "ds-docs-dialog-section-grid--wide" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      <DocsPreviewPanel title={title}>
        <div className="ds-docs-preview-surface ds-docs-dialog-preview">{children}</div>
      </DocsPreviewPanel>
      <DocsNiceToKnow intro={intro} items={notes} highlightTitle="Aufbau" highlightItems={highlights} />
    </div>
  );
}

function AppDialogPreview() {
  return (
    <AppDialog open inline size="md" onClose={() => {}}>
      <AppDialogHeader
        title="Dialog Title"
        subtitle="Optionaler Subtitle für Kontext oder nächsten Schritt."
        visual={<IconGlobal sx={{ fontSize: 16 }} />}
      />

      <AppDialogBody inset="none">
        <div className="ds-docs-dialog-bleed-example">
          Bleed body: geht über die volle Body-Breite.
        </div>
      </AppDialogBody>

      <AppDialogBody>
        <div className="ds-docs-dialog-inset-example">
          Inset body: folgt der normalen Lesekante des Dialogs.
        </div>
      </AppDialogBody>

      <AppDialogFooter
        startContent={(
          <AppText variant="body-2" tone="secondary">
            2 Änderungen
          </AppText>
        )}
      >
        <AppButton variant="neutral">Abbrechen</AppButton>
        <AppButton variant="primary">Speichern</AppButton>
      </AppDialogFooter>
    </AppDialog>
  );
}

function ConfirmDialogPreview() {
  return (
    <div className="ds-docs-dialog-confirm-stack">
      <AppConfirmDialog
        open
        inline
        icon={<IconInfo />}
        title="Aktion bestätigen"
        description="Soll diese Aktion ausgeführt werden?"
        confirmLabel="Bestätigen"
        onClose={() => {}}
        onConfirm={() => {}}
      />

      <AppConfirmDialog
        open
        inline
        icon={<IconDelete />}
        title="Löschen bestätigen"
        description="Möchtest du dieses Element wirklich löschen?"
        confirmLabel="Löschen"
        confirmTone="error"
        onClose={() => {}}
        onConfirm={() => {}}
      />
    </div>
  );
}

export default function DialogsDocs() {
  return (
    <DocsSectionCard title="Dialogs">
      <div className="ds-docs-dialogs">
        <DialogSection title="AppDialog" intro={appDialogIntro} notes={appDialogNotes} highlights={appDialogHighlights}>
          <AppDialogPreview />
        </DialogSection>

        <DialogSection
          title="AppConfirmDialog"
          intro={confirmDialogIntro}
          notes={confirmDialogNotes}
          highlights={confirmDialogHighlights}
          wide
        >
          <ConfirmDialogPreview />
        </DialogSection>
      </div>
    </DocsSectionCard>
  );
}
